import { Component, Inject, OnInit } from "@angular/core";
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { RfAuthenticationService } from "src/app/authentication/rf-authentication.service";
import { HierarchyManagementService } from "src/app/shared/service/store-management/hierarchy-management/hierarchy-management.service";
import { ProfileManagementService } from "src/app/shared/service/store-management/profile-management/profile-management.service";
import { BaseComponent } from "../../../base/base.component";
import { TitleWidgetComponent } from "../../../heading-widget/title-widget/title-widget.component";
import { MaterialModule } from "src/app/shared/module/material.module";
import { SalesChooseTableComponent } from "./sales-choose-table/sales-choose-table.component";
import { CommonModule } from "@angular/common";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";

@Component({
  selector: "ald-sales-choose",
  templateUrl: "./sales-choose.component.html",
  styleUrls: ["./sales-choose.component.scss"],
  standalone: true,
  imports: [
    TitleWidgetComponent,
    ReactiveFormsModule,
    MaterialModule,
    SalesChooseTableComponent,
    CommonModule,
    I18nPipe
  ]
})
export class SalesChooseComponent extends BaseComponent implements OnInit {
  closable = false;
  customerRetrieved;
  salesForm: UntypedFormGroup;
  salesIds;
  profiles;
  salesSelected;

  constructor(
    public dialogRef: MatDialogRef<SalesChooseComponent>,
    public authService: RfAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data,
    private _fb: UntypedFormBuilder,
    private router: Router,
    private profileManagement: ProfileManagementService,
    private hierarchyManagementService: HierarchyManagementService
  ) {
    super();
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    console.log(this.data);
    this.profiles = this.data.profiles;
    this.initForm();
    this.manageProfile();
    this.salesIdValueChange();
  }

  salesIdValueChange() {
    this.valueChanges(this.salesForm, "salesId").subscribe((salesIdChoosen) => {
      this.salesSelected = salesIdChoosen;
    });
  }

  manageProfile() {
    if (this.profiles.sl_references.length === 1) {
      this.salesSelected = this.profiles.sl_references[0];
    }
    if (this.profiles.sl_references.length > 1) {
      this.salesIds = this.profiles.sl_references;
    }
  }

  initForm() {
    this.salesForm = this._fb.group({
      salesId: [],
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onLogout(): void {
    this.authService.logout();
    this.dialogRef.close();
  }

  selectedSales(selectedSales) {
    const profile = this.profileManagement.getProfileByStore();
    profile.salesSetted = selectedSales;
    profile.sl_reference = this.salesSelected;
    this.profileManagement.setProfileInStore(profile);
    sessionStorage.setItem("profile", JSON.stringify(profile));
    if (!!!profile.registrationDate) {
      this.router.navigate(["/user/registration"]);
    } else {
      this.router.navigate(["/home"]);
    }
    this.dialogRef.close();
  }
}
